import React from 'react';

const WorkHeader = () => {
  return (
    <article className='space-y-4 w-full mx-auto text-center'>
      <h1 className='mx-auto text-center text-2xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight mb-16 sm:mb-28'>
        Full-stack web developer <br /> portfolio
      </h1>
      <div className='text-left max-w-4xl text-white'>
        <p className='sm:text-lg font-medium lg:text-xl lg:leading-9 space-y-5 mb-5 text-left'>
          From MVPs to Fully functional Live Websites, I've built many Apps in
          MERN Technology mostly with payment integrations,real-time chat
          integrations, deployment on AWS, high performance through redis on
          backend and best practices on frontend.
        </p>
      </div>
    </article>
  );
};

export default WorkHeader;
